export enum TabEnum {
    IntakeForm = 1,
    ABN,
    InformedConsent,
    PaymentAgreements,
    CommunicationsConsent,
    CCOF,
    ReceiptOfNOPP,
    PITemplate,
    Scribe
}

